import { ThemeProvider } from '@emotion/react';
import type { FunctionComponent } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import { IconArchive } from '~/ui/core/icons';
import { theme } from '~/ui/theme/cobrainer-theme';

import { DraftBadge, PublishedBadge, StatusIndicator } from '../../job-architecture-v2';
import type { LearningOpportunityState } from '../data-contract';
import { stateTranslationKey } from '../helpers';

export const CourseStateIndicator: FunctionComponent<{ readonly state: LearningOpportunityState }> = ({ state }) => {
    const translate = useTranslate();

    if (state === 'draft') {
        return (
            <ThemeProvider theme={theme}>
                <DraftBadge size="md" />
            </ThemeProvider>
        );
    }

    if (state === 'published') {
        return (
            <ThemeProvider theme={theme}>
                <PublishedBadge size="md" />
            </ThemeProvider>
        );
    }

    return (
        <StatusIndicator
            className="text-text-content-subtle"
            data-testid="review-state-archived"
            icon={<IconArchive size={12} />}
            size="md"
        >
            {translate(stateTranslationKey(state))}
        </StatusIndicator>
    );
};
